import React from "react";

const CtaTransportSection = () => {
  return (
    <section className="cta-transport-section py-5">
      <div className="container-lg text-center">

        <h2 className="cta-title mb-3" data-aos="fade-up" data-aos-delay="200">Book UAE Refrigerated Transport Now</h2>

        <p className="cta-desc mx-auto mb-4" data-aos="fade-up" data-aos-delay="300">
          Join <strong>UAE businesses</strong> keeping their cold supply safe with our{" "}
          <strong>chiller vans, freezer trucks, and refrigerated vehicles</strong>—available across{" "}
          <strong>Dubai, Abu Dhabi, Sharjah, UAE, Ajman, and Ras Al Khaimah</strong>.
        </p>

        <div className="cta-contact mb-5" data-aos="fade-up" data-aos-delay="400">
          <a href="tel:+971544792905" className="cta-contact-link">
            <i className="bi bi-telephone-fill me-2"></i>
            Call: +971 54 479 2905
          </a>
          <a
            href="https://wa.me/971544792905"
            target="_blank"
            rel="noreferrer"
            className="cta-contact-link whatsapp"
          >
            <i className="bi bi-whatsapp me-2"></i>
            Get Instant Quote
          </a>
        </div>

        <h3 className="cta-subtitle mb-4" data-aos="fade-down" data-aos-delay="400">Why Choose Chiller Fleet Chiller Van?</h3>

        <div className="row g-4 justify-content-center">
          <div className="col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="cta-card h-100">
              <i className="bi bi-truck"></i>
              <h5>Licensed Transport Operator</h5>
              <p>Fully approved refrigerated transport services across UAE cities.</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="cta-card h-100">
              <i className="bi bi-headset"></i>
              <h5>24/7 Customer Support</h5>
              <p>Available anytime for urgent deliveries and booking assistance.</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="cta-card h-100">
              <i className="bi bi-thermometer-half"></i>
              <h5>Temperature Controlled Fleet</h5>
              <p>Advanced cooling technology to protect frozen and chilled goods.</p>
            </div>
          </div>
        </div>

        <div className="mt-5" data-aos="fade-down" data-aos-delay="400">
          <a href="https://wa.me/971544792905" className="btn--primary">
            <i className="bi bi-calendar-check me-2"></i> Book Today
          </a>
          <p className="cta-note mt-3">
            Reliable refrigerated transport services across the UAE
          </p>
        </div>

      </div>
    </section>
  );
};

export default CtaTransportSection;
